module.exports = __webpack_public_path__ + "static/liva-test.d-a2e1ef5e9b0fbde339559834bb3846f5.webp";